import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 526px;
  background-color: ${p => p.theme.color.backgroundRush};

  &, * {
    box-sizing: border-box;
  }
`;

export const Styled = {
  Container,
};
